export enum Status {
  ready = 'Ready',
  inProgress = 'inProgress',
  completed = 'Completed',
}
